'use strict';

import _ from 'lodash';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import PaymentPlanLang from './PaymentPlanLang';
import CurrencyPropType from './CurrencyPropType.jsx';

import './PaymentPlan.less';

export default class TrialPaymentPlan extends React.Component {
	render() {
		const classes = classnames(
			'PaymentPlan',
			'TrialPaymentPlan',
			'TrialPaymentPlanLike',
			`product${_.upperFirst(this.props.product)}`,
			this.props.className,
			this.props.translucent && 'PaymentPlan--translucent'
		);

		return (
			<div className="Payment__wrapper">
				<div className={classes} onClick={this.props.onClick} id="plan-trial" key="plan-trial">
					<div className="productName">{this.props.productName}</div>

					<div className="name">{PaymentPlanLang.TRIAL.NAME}</div>

					<div
						className="price"
						dangerouslySetInnerHTML={{
							__html: CK.fn.formatPrice(this.props.currency, 0, {
								stylish: true,
								html: true,
								spaceCurrencySymbol: true
							})
						}}
					/>

					<div className="billingDescription">{PaymentPlanLang.TRIAL.DESCRIPTION}</div>
				</div>
			</div>
		);
	}
}

TrialPaymentPlan.propTypes = {
	onClick: PropTypes.func.isRequired,
	currency: CurrencyPropType.isRequired,
	productName: PropTypes.string.isRequired,
	product: PropTypes.string.isRequired,
	className: PropTypes.string,
	translucent: PropTypes.bool
};
